export default "__VITE_ASSET__1f8bcb2b__"